import type { PointData } from 'pixi.js';
import { Container } from 'pixi.js';
import { TutorialHandLayout } from '../../../../layouts/common/TutorialHandLayout';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';
import MathUtils from '../../../utils/MathUtils';

export class TutorialHand extends Container {
  private readonly layout = new TutorialHandLayout();

  constructor() {
    super();
    this.layout.root.props({ parent: this });
    this.alpha = 0;
    this.interactiveChildren = false;
  }

  public setClicking(): this {
    this.tweenTo({ alpha: 1 }, 100, 'sinOut', true);
    void playLayoutAnimation(this.layout, 'Tap', true);
    return this;
  }

  public setDrag(globalPosition: PointData): this {
    void this.animateDrag(globalPosition);
    return this;
  }

  private async animateDrag(globalPosition: PointData): Promise<void> {
    if (this.destroyed) return;

    const { x: targetX, y: targetY } = this.toLocal(globalPosition);

    const distance = MathUtils.getDistance(0, 0, targetX, targetY);

    this.layout.root.props({ x: 0, y: 0 });
    this.tweenTo({ alpha: 1 }, 100, 'sinOut', true);
    await playLayoutAnimation(this.layout, 'DragStart');
    await this.layout.root.tweenTo({ x: targetX, y: targetY }, distance * 4, 'sinInOut', true).asyncOnComplete();
    await playLayoutAnimation(this.layout, 'DragEnd');
    await this.tweenTo({ alpha: 0 }, 200, 'sinOut', true).asyncOnComplete();
    void this.animateDrag(globalPosition);
  }

  public destroy(): void {
    this.tweenTo({ alpha: 0 }, 100, 'sinIn', true).onComplete.add(() => {
      super.destroy({ children: true });
    });
  }
}
